/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';
import { SalesQuotePriceListUpdateDto } from '../../models/sales-quote-price-list-update-dto';

export interface QuotePriceListsControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote price list to update.
 */
  id: string;
      body: SalesQuotePriceListUpdateDto
}

export function quotePriceListsControllerUpdate(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuotePriceListResponseDto>;
    })
  );
}

quotePriceListsControllerUpdate.PATH = '/o2-sales/quote-price-lists/{tenant}/{id}';
